var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.CustomsDeclarationInfo"),
        width: "500px",
        "close-on-click-modal": false,
        "append-to-body": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-width": _vm.closeXhqCustoms ? "65px" : "85px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.closeXhqCustoms,
                  expression: "closeXhqCustoms"
                }
              ],
              attrs: { label: _vm.$t("SeaExport.SequenceNumber") }
            },
            [
              _c("el-input", {
                staticStyle: { width: "50%" },
                attrs: { no: "1" },
                model: {
                  value: _vm.oneFormData.level,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "level", $$v)
                  },
                  expression: "oneFormData.level"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.closeXhqCustoms,
                  expression: "closeXhqCustoms"
                }
              ],
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.TenBitCode") }
            },
            [
              _c(
                "el-select",
                {
                  ref: "tenDigitCode",
                  staticStyle: { width: "150px" },
                  attrs: {
                    value: _vm.oneFormData.tenDigitCode,
                    filterable: "",
                    clearable: "",
                    "allow-create": true,
                    no: "2"
                  },
                  on: {
                    input: _vm.tenDigitCodeChangeHandler,
                    blur: _vm.tenDigitCodeFocusOutHandler
                  }
                },
                _vm._l(_vm.bussinessList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: {
                      label: item.tenDigitCode,
                      value: item.tenDigitCode
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.closeXhqCustoms && !_vm.isSalesForSzfs,
                  expression: "closeXhqCustoms && !isSalesForSzfs"
                }
              ],
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.OperatingCompany") }
            },
            [
              _c(
                "el-select",
                {
                  ref: "companyCname",
                  staticStyle: { width: "250px" },
                  attrs: {
                    value: _vm.oneFormData.companyCname,
                    filterable: "",
                    clearable: "",
                    "allow-create": true,
                    no: "3"
                  },
                  on: {
                    input: _vm.queryBusinessHandler,
                    blur: _vm.companyCnameFocusOutHandler
                  }
                },
                _vm._l(_vm.bussinessList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: {
                      label: item.companyCname,
                      value: item.companyCname
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.closeXhqCustoms,
                  expression: "closeXhqCustoms"
                }
              ],
              attrs: { label: _vm.$t("SeaExport.BusinessNo") }
            },
            [
              _c("el-input", {
                attrs: { disabled: true, no: "4" },
                model: {
                  value: _vm.job.jobNo,
                  callback: function($$v) {
                    _vm.$set(_vm.job, "jobNo", $$v)
                  },
                  expression: "job.jobNo"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.closeXhqCustoms,
                  expression: "!closeXhqCustoms"
                }
              ],
              attrs: { label: _vm.$t("SeaExport.CBANumber") }
            },
            [
              _c("el-input", {
                attrs: { disabled: true, no: "4" },
                model: {
                  value: _vm.oneFormData.cbaNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "cbaNumber", $$v)
                  },
                  expression: "oneFormData.cbaNumber"
                }
              })
            ],
            1
          ),
          _vm.soNoFromCustomsDeclaration
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.SoNo") } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { no: "soNo", clearable: "" },
                      on: { change: _vm.poItemsUuidChangeHandler },
                      model: {
                        value: _vm.oneFormData.poItemsUuid,
                        callback: function($$v) {
                          _vm.$set(_vm.oneFormData, "poItemsUuid", $$v)
                        },
                        expression: "oneFormData.poItemsUuid"
                      }
                    },
                    _vm._l(_vm.poItems, function(item) {
                      return _c("el-option", {
                        key: item.uuid,
                        attrs: {
                          label:
                            (item.soNo
                              ? item.soNo
                              : _vm.$t("CargoMsg.Cargo_Empty2")) +
                            "    " +
                            _vm.$t("CargoMsg.Cargo_QuantityWeightCubage") +
                            " : " +
                            item.quantity +
                            "/" +
                            item.grossWeight +
                            "/" +
                            item.cubage,
                          value: item.uuid
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.SoNo") } },
                [
                  _vm.job.booking
                    ? _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: !_vm.isExport,
                            no: "5",
                            clearable: !_vm.closeXhqCustoms
                          },
                          model: {
                            value: _vm.oneFormData.soNo,
                            callback: function($$v) {
                              _vm.$set(_vm.oneFormData, "soNo", $$v)
                            },
                            expression: "oneFormData.soNo"
                          }
                        },
                        _vm._l(_vm.soNoList, function(value) {
                          return _c("el-option", {
                            key: value,
                            attrs: { label: value, value: value }
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                  !_vm.job.booking
                    ? _c("el-input", {
                        model: {
                          value: _vm.oneFormData.soNo,
                          callback: function($$v) {
                            _vm.$set(_vm.oneFormData, "soNo", $$v)
                          },
                          expression: "oneFormData.soNo"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
          _vm.soNoFromCustomsDeclaration
            ? _c(
                "div",
                {
                  staticStyle: { "margin-bottom": "10px", "margin-left": "8px" }
                },
                [
                  _c("label", { staticStyle: { "margin-right": "4px" } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))
                  ]),
                  _c("el-input", {
                    staticStyle: { width: "80px" },
                    attrs: {
                      disabled: "",
                      type: "number",
                      no: "quantityActual2"
                    },
                    model: {
                      value: _vm.oneFormData.quantityActual,
                      callback: function($$v) {
                        _vm.$set(_vm.oneFormData, "quantityActual", $$v)
                      },
                      expression: "oneFormData.quantityActual"
                    }
                  }),
                  _c(
                    "label",
                    {
                      staticStyle: {
                        "margin-left": "10px",
                        "margin-right": "4px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.WeightKg")))]
                  ),
                  _c("el-input", {
                    staticStyle: { width: "80px" },
                    attrs: {
                      disabled: "",
                      type: "number",
                      no: "weightActual2"
                    },
                    model: {
                      value: _vm.oneFormData.weightActual,
                      callback: function($$v) {
                        _vm.$set(_vm.oneFormData, "weightActual", $$v)
                      },
                      expression: "oneFormData.weightActual"
                    }
                  }),
                  _c(
                    "label",
                    {
                      staticStyle: {
                        "margin-left": "10px",
                        "margin-right": "4px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CubageCbm")))]
                  ),
                  _c("el-input", {
                    staticStyle: { width: "80px" },
                    attrs: {
                      disabled: "",
                      type: "number",
                      no: "cubageActual2"
                    },
                    model: {
                      value: _vm.oneFormData.cubageActual,
                      callback: function($$v) {
                        _vm.$set(_vm.oneFormData, "cubageActual", $$v)
                      },
                      expression: "oneFormData.cubageActual"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.closeXhqCustoms,
                  expression: "closeXhqCustoms"
                }
              ],
              attrs: { label: _vm.$t("CargoMsg.Cargo_CustomsDeclarationNo") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.oneFormData.customsDeclarationNo,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "customsDeclarationNo", $$v)
                  },
                  expression: "oneFormData.customsDeclarationNo"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.closeXhqCustoms,
                  expression: "closeXhqCustoms"
                }
              ],
              attrs: { label: _vm.$t("SeaExport.CustomsNo") }
            },
            [
              _c("el-input", {
                attrs: { no: "6" },
                model: {
                  value: _vm.oneFormData.customsNo,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "customsNo", $$v)
                  },
                  expression: "oneFormData.customsNo"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isSalesForSzfs,
                  expression: "!isSalesForSzfs"
                }
              ],
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.CustomsBroker") }
            },
            [
              _c("cargo-company-select", {
                staticStyle: { width: "250px" },
                attrs: {
                  "method-params": { customsBroker: true, active: true },
                  "default-value": _vm.oneFormData.customsBroker || "",
                  no: "7"
                },
                on: {
                  change: function(p) {
                    _vm.oneFormData.customsBroker = p.value || 0
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.closeXhqCustoms,
                  expression: "closeXhqCustoms"
                }
              ],
              attrs: { label: _vm.$t("SeaExport.DateOfCustomsDeclaration") }
            },
            [
              _c("el-date-picker", {
                staticStyle: { width: "150px" },
                attrs: {
                  editable: false,
                  clearable: false,
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                  no: "8"
                },
                model: {
                  value: _vm.oneFormData.customsDate,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "customsDate", $$v)
                  },
                  expression: "oneFormData.customsDate"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.closeXhqCustoms,
                  expression: "!closeXhqCustoms"
                }
              ],
              attrs: { label: _vm.$t("CargoMsg.CustomsDeclareTime") }
            },
            [
              _c("el-date-picker", {
                staticStyle: { width: "150px" },
                attrs: {
                  no: "declareTime",
                  editable: false,
                  clearable: false,
                  type: "datetime",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  format: "yyyy-MM-dd HH:mm:ss"
                },
                model: {
                  value: _vm.oneFormData.declareTime,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "declareTime", $$v)
                  },
                  expression: "oneFormData.declareTime"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.closeXhqCustoms,
                  expression: "!closeXhqCustoms"
                }
              ],
              attrs: { label: _vm.$t("CargoMsg.NoticeBgh") }
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "150px" },
                  attrs: { no: "noticeBgh" },
                  model: {
                    value: _vm.oneFormData.noticeBgh,
                    callback: function($$v) {
                      _vm.$set(_vm.oneFormData, "noticeBgh", $$v)
                    },
                    expression: "oneFormData.noticeBgh"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "Y", value: true } }),
                  _c("el-option", { attrs: { label: "N", value: false } })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.closeXhqCustoms,
                  expression: "!closeXhqCustoms"
                }
              ],
              attrs: { label: _vm.$t("CargoMsg.VerificationSheetRequired") }
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "150px" },
                  attrs: { no: "verificationSheetRequired" },
                  model: {
                    value: _vm.oneFormData.verificationSheetRequired,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.oneFormData,
                        "verificationSheetRequired",
                        $$v
                      )
                    },
                    expression: "oneFormData.verificationSheetRequired"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "Y", value: true } }),
                  _c("el-option", { attrs: { label: "N", value: false } })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.closeXhqCustoms,
                  expression: "closeXhqCustoms"
                }
              ],
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.StatusOfCustomsDeclaration") }
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "150px" },
                  attrs: { no: "9" },
                  model: {
                    value: _vm.oneFormData.declareCustomsState,
                    callback: function($$v) {
                      _vm.$set(_vm.oneFormData, "declareCustomsState", $$v)
                    },
                    expression: "oneFormData.declareCustomsState"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: _vm.$t("SeaExport.PleaseSelect"), value: 0 }
                  }),
                  _c("el-option", {
                    attrs: { label: _vm.$t("SeaExport.Recorded"), value: 1 }
                  }),
                  _c("el-option", {
                    attrs: { label: _vm.$t("SeaExport.ListPulled"), value: 2 }
                  }),
                  _c("el-option", {
                    attrs: { label: _vm.$t("SeaExport.AtReception"), value: 3 }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.CustomsDeclared"),
                      value: 4
                    }
                  }),
                  _c("el-option", {
                    attrs: { label: _vm.$t("SeaExport.Undeclared"), value: 5 }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.CustomsExamination"),
                      value: 6
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.InspectionExamination"),
                      value: 7
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.ExamedWithoutReleasing"),
                      value: 8
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.AmendDeclaration"),
                      value: 9
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.NotifyToDeclare"),
                      value: 10
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.CustomsHasCheck"),
                      value: 11
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.CustomsExamed"),
                      value: 12
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.CustomsOneRelease"),
                      value: 13
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.CustomsRelease2"),
                      value: 14
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.closeXhqCustoms,
                  expression: "closeXhqCustoms"
                }
              ],
              staticClass: "custom"
            },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { no: "10" },
                  model: {
                    value: _vm.oneFormData.commodityInspection,
                    callback: function($$v) {
                      _vm.$set(_vm.oneFormData, "commodityInspection", $$v)
                    },
                    expression: "oneFormData.commodityInspection"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.CommodityInspectionOrNot")))]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { no: "11" },
                  model: {
                    value: _vm.oneFormData.spotInspection,
                    callback: function($$v) {
                      _vm.$set(_vm.oneFormData, "spotInspection", $$v)
                    },
                    expression: "oneFormData.spotInspection"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsInspectionOrNot")))]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.closeXhqCustoms,
                  expression: "closeXhqCustoms"
                }
              ],
              attrs: { label: _vm.$t("SeaExport.CustomsDeclarationType") }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    value: _vm.oneFormData.declareCustomsType || "",
                    placeholder: _vm.$t("common.tips.pleaseChoose"),
                    no: "12"
                  },
                  on: {
                    input: function(value) {
                      _vm.oneFormData.declareCustomsType = value
                    }
                  }
                },
                _vm._l(_vm.customsDeclarationTypes, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.chineseName, value: item.code }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.closeXhqCustoms,
                  expression: "closeXhqCustoms"
                }
              ],
              attrs: { label: _vm.$t("SeaExport.PreNumber") }
            },
            [
              _c("el-input", {
                attrs: { no: "13" },
                model: {
                  value: _vm.oneFormData.preNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "preNumber", $$v)
                  },
                  expression: "oneFormData.preNumber"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.closeXhqCustoms,
                  expression: "closeXhqCustoms"
                }
              ],
              attrs: { label: _vm.$t("SeaExport.PlateNumber") }
            },
            [
              _c("el-input", {
                attrs: { no: "14" },
                model: {
                  value: _vm.oneFormData.plateNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "plateNumber", $$v)
                  },
                  expression: "oneFormData.plateNumber"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.closeXhqCustoms,
                  expression: "closeXhqCustoms"
                }
              ],
              attrs: { label: _vm.$t("SeaExport.ContainerNo2") }
            },
            [
              _c("el-input", {
                attrs: { no: "15" },
                model: {
                  value: _vm.oneFormData.containerNo,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "containerNo", $$v)
                  },
                  expression: "oneFormData.containerNo"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.closeXhqCustoms,
                      expression: "closeXhqCustoms"
                    }
                  ],
                  attrs: { label: _vm.$t("SeaExport.Quantity2") }
                },
                [
                  _c("auto-number-input", {
                    attrs: { precision: 2, no: "quantity" },
                    model: {
                      value: _vm.oneFormData.quantity,
                      callback: function($$v) {
                        _vm.$set(_vm.oneFormData, "quantity", $$v)
                      },
                      expression: "oneFormData.quantity"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.closeXhqCustoms,
                      expression: "closeXhqCustoms"
                    }
                  ],
                  attrs: { label: _vm.$t("SeaExport.itemCount") }
                },
                [
                  _c("auto-number-input", {
                    attrs: { precision: 2, no: "number" },
                    model: {
                      value: _vm.oneFormData.number,
                      callback: function($$v) {
                        _vm.$set(_vm.oneFormData, "number", $$v)
                      },
                      expression: "oneFormData.number"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.closeXhqCustoms,
                      expression: "closeXhqCustoms"
                    }
                  ],
                  attrs: { label: _vm.$t("SeaExport.Weight") }
                },
                [
                  _c("auto-number-input", {
                    attrs: { precision: 3, no: "weight" },
                    model: {
                      value: _vm.oneFormData.weight,
                      callback: function($$v) {
                        _vm.$set(_vm.oneFormData, "weight", $$v)
                      },
                      expression: "oneFormData.weight"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.closeXhqCustoms,
                      expression: "closeXhqCustoms"
                    }
                  ],
                  attrs: { label: _vm.$t("SeaExport.ExchangeRate") }
                },
                [
                  _c("auto-number-input", {
                    attrs: { precision: 2, no: "rate" },
                    model: {
                      value: _vm.oneFormData.rate,
                      callback: function($$v) {
                        _vm.$set(_vm.oneFormData, "rate", $$v)
                      },
                      expression: "oneFormData.rate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.closeXhqCustoms,
                      expression: "closeXhqCustoms"
                    }
                  ],
                  attrs: { label: _vm.$t("CargoMsg.Cargo_SystemFee") }
                },
                [
                  _c("auto-number-input", {
                    attrs: { precision: 2, no: "systemFee" },
                    model: {
                      value: _vm.oneFormData.systemFee,
                      callback: function($$v) {
                        _vm.$set(_vm.oneFormData, "systemFee", $$v)
                      },
                      expression: "oneFormData.systemFee"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.closeXhqCustoms,
                      expression: "closeXhqCustoms"
                    }
                  ],
                  attrs: { label: _vm.$t("CargoMsg.Cargo_InsurancePremium") }
                },
                [
                  _c("auto-number-input", {
                    attrs: { precision: 2, no: "insurancePremium" },
                    model: {
                      value: _vm.oneFormData.insurancePremium,
                      callback: function($$v) {
                        _vm.$set(_vm.oneFormData, "insurancePremium", $$v)
                      },
                      expression: "oneFormData.insurancePremium"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.closeXhqCustoms,
                      expression: "closeXhqCustoms"
                    }
                  ],
                  attrs: { label: _vm.$t("CargoMsg.Cargo_ProcessingFee") }
                },
                [
                  _c("auto-number-input", {
                    attrs: { precision: 2, no: "processingFee" },
                    model: {
                      value: _vm.oneFormData.processingFee,
                      callback: function($$v) {
                        _vm.$set(_vm.oneFormData, "processingFee", $$v)
                      },
                      expression: "oneFormData.processingFee"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.closeXhqCustoms,
                      expression: "closeXhqCustoms"
                    }
                  ],
                  attrs: { label: _vm.$t("CargoMsg.Cargo_FOBValue") }
                },
                [
                  _c("auto-number-input", {
                    attrs: { precision: 2, no: "freeOnBoard" },
                    model: {
                      value: _vm.oneFormData.freeOnBoard,
                      callback: function($$v) {
                        _vm.$set(_vm.oneFormData, "freeOnBoard", $$v)
                      },
                      expression: "oneFormData.freeOnBoard"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.Remarks") } },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: 3, no: "16" },
                model: {
                  value: _vm.oneFormData.remarks,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "remarks", $$v)
                  },
                  expression: "oneFormData.remarks"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openXhqCustomsAll,
                  expression: "openXhqCustomsAll"
                }
              ],
              attrs: { label: _vm.$t("CargoMsg.PushOrNot") }
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "150px" },
                  attrs: { no: "pushOrNot" },
                  model: {
                    value: _vm.oneFormData.pushOrNot,
                    callback: function($$v) {
                      _vm.$set(_vm.oneFormData, "pushOrNot", $$v)
                    },
                    expression: "oneFormData.pushOrNot"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "Y", value: true } }),
                  _c("el-option", { attrs: { label: "N", value: false } })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.closeXhqCustoms &&
                    _vm.oneFormData.xhqCustomState !==
                      _vm.XhqCustomState.SENT.code &&
                    _vm.oneFormData.xhqCustomState !==
                      _vm.XhqCustomState.SENT_LCL_TASK.code,
                  expression:
                    "(!closeXhqCustoms && oneFormData.xhqCustomState !== XhqCustomState.SENT.code && oneFormData.xhqCustomState !== XhqCustomState.SENT_LCL_TASK.code)"
                }
              ],
              attrs: { label: _vm.$t("SeaExport.CustomsInformation") }
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "17" },
                  on: { click: _vm.toQuery }
                },
                [_vm._v(_vm._s(_vm.$t("FileHistory.Refresh")))]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "primary", no: "18" },
                  on: { click: _vm.shouCloudUpload }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.AddFile")))]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "danger", no: "19" },
                  on: { click: _vm.remove }
                },
                [_vm._v(_vm._s(_vm.$t("FileHistory.Delete")))]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.openXhqCustomsAll &&
                    (_vm.oneFormData.xhqCustomState ===
                      _vm.XhqCustomState.SENT.code ||
                      _vm.oneFormData.xhqCustomState ===
                        _vm.XhqCustomState.SENT_LCL_TASK.code),
                  expression:
                    "openXhqCustomsAll && (oneFormData.xhqCustomState === XhqCustomState.SENT.code || oneFormData.xhqCustomState === XhqCustomState.SENT_LCL_TASK.code)"
                }
              ],
              attrs: { label: _vm.$t("SeaExport.CustomsInformation") }
            },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "toXhqRecallCustomsFiles", type: "danger" },
                  on: { click: _vm.toXhqRecallCustomsFiles }
                },
                [_vm._v(_vm._s(_vm.$t("Message.Withdraw")))]
              )
            ],
            1
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.closeXhqCustoms,
                  expression: "!closeXhqCustoms"
                }
              ],
              staticStyle: { "margin-left": "10px", color: "red" }
            },
            [_vm._v(_vm._s(_vm.$t("Message.ReminderOfTheCustomsData")))]
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.closeXhqCustoms,
                  expression: "!closeXhqCustoms"
                }
              ],
              staticClass: "custom",
              staticStyle: { "margin-top": "5px" },
              attrs: { "label-width": "0" }
            },
            [
              _c(
                "div",
                { staticStyle: { height: "200px" } },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%", height: "180px" },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData
                    },
                    on: {
                      gridReady: function(params) {
                        return (_vm.gridApi = params.api)
                      }
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.closeXhqCustoms,
                  expression: "!closeXhqCustoms"
                }
              ],
              staticStyle: { "margin-left": "10px", color: "red" }
            },
            [_vm._v(_vm._s(_vm.$t("Message.ReminderOfTheCustomsPrint")))]
          ),
          _c("br", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.closeXhqCustoms,
                expression: "!closeXhqCustoms"
              }
            ]
          }),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.closeXhqCustoms && !_vm.slaveCustomsDeclarationEnable,
                  expression:
                    "!closeXhqCustoms && !slaveCustomsDeclarationEnable"
                }
              ],
              attrs: { type: "text", no: "ObtainActualData" },
              on: { click: _vm.getActualData }
            },
            [_vm._v(_vm._s(_vm.$t("Message.ObtainActualBusinessData")))]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.closeXhqCustoms && !_vm.slaveCustomsDeclarationEnable,
                  expression:
                    "!closeXhqCustoms && !slaveCustomsDeclarationEnable"
                }
              ],
              staticStyle: { "margin-bottom": "10px", "margin-left": "8px" }
            },
            [
              _c("label", { staticStyle: { "margin-right": "4px" } }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))
              ]),
              _c("el-input", {
                staticStyle: { width: "80px" },
                attrs: { type: "number", no: "quantityActual" },
                model: {
                  value: _vm.oneFormData.quantityActual,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "quantityActual", $$v)
                  },
                  expression: "oneFormData.quantityActual"
                }
              }),
              _c(
                "label",
                {
                  staticStyle: { "margin-left": "10px", "margin-right": "4px" }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.WeightKg")))]
              ),
              _c("el-input", {
                staticStyle: { width: "80px" },
                attrs: { type: "number", no: "weightActual" },
                model: {
                  value: _vm.oneFormData.weightActual,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "weightActual", $$v)
                  },
                  expression: "oneFormData.weightActual"
                }
              }),
              _c(
                "label",
                {
                  staticStyle: { "margin-left": "10px", "margin-right": "4px" }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.CubageCbm")))]
              ),
              _c("el-input", {
                staticStyle: { width: "80px" },
                attrs: { type: "number", no: "cubageActual" },
                model: {
                  value: _vm.oneFormData.cubageActual,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "cubageActual", $$v)
                  },
                  expression: "oneFormData.cubageActual"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.cloudFile.job,
          lob: _vm.cloudFile.lob,
          "from-lob": _vm.cloudFile.fromLob,
          "file-size": _vm.cloudFile.fileSize,
          "upload-files": _vm.cloudFile.uploadFiles,
          "show-drop": _vm.job.lob === "SE",
          "other-param": _vm.otherParam
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadDone: _vm.updateSop
        }
      }),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "20" },
              on: { click: _vm.enterHandler }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.openXhqCustomsAll &&
                    _vm.isEdit &&
                    !_vm.openMeiHuaCustom,
                  expression: "openXhqCustomsAll && isEdit && !openMeiHuaCustom"
                }
              ],
              attrs: { no: "xhqSendHandler", type: "primary" },
              on: { click: _vm.sendHandler }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Send")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "21" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }